<template>
  <div>
    <div class="has-background-white">
      <div class="contact-background"></div>
      <div
        class="margin-top-minus-95 rounded-10 container"
        :class="
          screen === 'mobile' ? 'pa-4' : 'padding-right-80px padding-left-80px'
        "
      >
        <div class="mb-5 box pa-4 rounded-10">
          <div class="has-text-weight-semibold is-size-4 mb-3">
            {{ $t('Rojgari Service Pvt. Ltd.') }}
          </div>
          <div class="is-flex gap-1 mb-3 is-flex-wrap">
            <div class="is-flex">
              <vue-icon-base
                height="20"
                :path="$options.icons[$kc('uni-phone')]"
                width="20"
                icon-color="#F99D1E"
              >
              </vue-icon-base>
              <p class="has-text-weight-medium text-orange ml-2">01-5970069</p>
            </div>
            <div class="is-flex">
              <vue-icon-base
                height="20"
                :path="$options.icons[$kc('uni-envelope')]"
                width="20"
                icon-color="#7a7a7a"
              >
              </vue-icon-base>
              <p class="has-text-weight-medium has-text-grey ml-2">
                info@rojgari.com
              </p>
            </div>
          </div>
          <p class="has-text-weight-medium has-text-grey mb-3">
            Min Bhawan Main Road, Opposite to Shantinagar Gate, Kathmandu, Nepal
          </p>
          <div
            class="columns rounded-10 outline pa-0 is-full-width overflow-hidden ma-0"
          >
            <div class="column is-6 pa-0">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14131.925645196774!2d85.3424835!3d27.6869694!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x90de277403fb0368!2sRojgari%20Pasal!5e0!3m2!1sen!2snp!4v1575012266620!5m2!1sen!2snp"
                class="is-full-width fill-height"
              ></iframe>
            </div>
            <div class="column is-6 pa-4">
              <contact-us
                :key="componentKey"
                @create="componentKey += 1"
              ></contact-us>
            </div>
          </div>
        </div>
      </div>

      <section class="is-flex overflow-hidden pa-4">
        <div
          class="container"
          :class="
            screen === 'mobile' ? '' : 'padding-right-80px padding-left-80px'
          "
        >
          <div class="is-size-3 has-text-weight-medium pb-3 has-text-centered">
            {{ $t('Rojgari App') }}
          </div>
          <div class="container columns">
            <div
              class="column is-6 is-flex is-flex-direction-column gap-1 pa-4 has-text-centered-mobile"
            >
              <p class="margin-top-auto">
                Employment to the unemployed, Employee to the Employer, Rojgari
                Pasal is with you, employment is on your hand !!
              </p>
              <div>
                <span class="has-text-weight-semibold">Download</span
                ><a
                  class="text-orange has-text-weight-semibold pointer"
                  href="https://play.google.com/store/apps/details?id=com.rojgaripasal.rojgariapp"
                  target="_blank"
                >
                  Rojgari App
                </a>
                <span class="has-text-weight-semibold"> Today</span>
              </div>
              <div
                class="is-flex is-flex-direction-row margin-bottom-auto gap-1 is-flex-wrap download"
              >
                <a
                  id="btn-download-app-google"
                  class="text-orange has-text-weight-semibold pointer"
                  href="https://play.google.com/store/apps/details?id=com.rojgaripasal.rojgariapp"
                  target="_blank"
                >
                  <img src="/images/account/android_download.png" />
                </a>
                <a
                  id="btn-download-app-google"
                  class="text-orange has-text-weight-semibold pointer"
                  href="https://apps.apple.com/us/app/rojgari/id1493964641?ign-mpt=uo%3D2"
                  target="_blank"
                >
                  <img src="/images/account/apple_download.png" />
                </a>
              </div>
            </div>
            <div class="column is-6 pa-0">
              <img
                src="/images/account/new-app-showcase.png"
                class="is-pulled-right"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import VueIconBase from '@/components/Commons/VueIconBase'
import ContactUs from '@/components/Commons/Forms/ContactUs'
import { uniPhone, uniGlobe, uniMapMarker, uniEnvelope } from '@/helpers/icons'
import { mapGetters } from 'vuex'
export default {
  icons: {
    uniPhone,
    uniGlobe,
    uniMapMarker,
    uniEnvelope
  },
  components: { VueIconBase, ContactUs },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  data() {
    return {
      componentKey: 1
    }
  },
  head() {
    return {
      title: 'Contact Us | Rojgari'
    }
  }
}
</script>
<style>
.contact-background {
  background-color: orange;
  background-size: cover;
  background-position: right top;
  height: 16rem;
}
@media screen and (max-width: 768px) {
  .download {
    place-content: center;
  }
}
</style>
